angular.module('unergie.main')
.directive('jsonarraydetails', () =>
    ({
        restrict: 'E',
        templateUrl: '/directives/jsonarraydetails/jsonarraydetails.html',
        scope: {
            details: '=',
            parse: '=',
            key: '=',
            object: '=',
        },
        link($scope) {
            if ($scope.parse) {
                $scope.details = JSON.parse($scope.details)
            }
        },
    }),
)
